const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Promos Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23074",
    d: "M0 0h24v24H0z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26719",
    d: "M.421 17.061a1.931 1.931 0 0 1-.43-1.317q.012-5 0-10a.984.984 0 0 1 .268-.711q.965-1.062 1.9-2.149a.761.761 0 0 0 .164-.438c.019-.6 0-1.192.009-1.788A.579.579 0 0 1 2.985.01Q4.67 0 6.355.01a.59.59 0 0 1 .658.65c.007.554 0 1.109 0 1.694.547 0 1.063.011 1.578 0a.882.882 0 0 1 .722.3q2.21 2.367 4.437 4.716a.984.984 0 0 1 .287.733q-.012 3.8 0 7.592A1.908 1.908 0 0 1 13.66 17a5.085 5.085 0 0 1 .354 1.081A1.715 1.715 0 0 1 12.227 20c-1.954.006-3.908 0-5.862 0-1.456 0-2.912-.013-4.366 0a1.846 1.846 0 0 1-1.8-.925 1.814 1.814 0 0 1 .219-2.015zm.747-2.837c.162-.03.275-.055.39-.073a.63.63 0 0 1 .768.5c.053.335-.183.6-.579.662a.586.586 0 0 0-.573.669c.032.285.222.448.588.5a.607.607 0 0 1 .572.6.6.6 0 0 1-.558.576c-.428.064-.629.277-.6.64.022.332.272.532.677.532h10.344c.4 0 .649-.207.667-.544.019-.353-.184-.568-.587-.627a.6.6 0 0 1-.574-.587.6.6 0 0 1 .581-.585q.575-.084.581-.571c.006-.336-.2-.546-.586-.6a.594.594 0 0 1-.573-.642.622.622 0 0 1 .723-.524c.134.015.266.045.417.072.008-.1.02-.172.02-.248 0-1.875 0-3.752-.007-5.627a.615.615 0 0 0-.168-.375q-2-2.143-4.013-4.268a.577.577 0 0 0-.378-.167q-2.447-.016-4.894 0a.6.6 0 0 0-.39.182c-.557.6-1.091 1.225-1.645 1.831a.748.748 0 0 0-.212.546q.011 3.884 0 7.767v.363zM3.523 2.338h2.3V1.2h-2.3v1.139z",
    transform: "translate(5.014 1.992)",
    style: {
      strokeWidth: ".5px",
      stroke: "currentColor",
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26720",
    d: "M53.141 44.559A1.724 1.724 0 0 1 52.1 46.18a1.653 1.653 0 0 1-1.919-.349 91.573 91.573 0 0 1-2.8-2.982 1.748 1.748 0 0 1 2.541-2.395c.948.968 1.867 1.965 2.791 2.957a1.594 1.594 0 0 1 .435 1.148zm-1.1.032a3.1 3.1 0 0 0-.3-.488c-.486-.533-.988-1.054-1.483-1.58-.382-.4-.758-.815-1.146-1.213a.581.581 0 0 0-.727-.091.546.546 0 0 0-.247.635.968.968 0 0 0 .232.362q1.238 1.329 2.485 2.647a1.3 1.3 0 0 0 .217.193.483.483 0 0 0 .6.006 2.644 2.644 0 0 0 .366-.472z",
    transform: "translate(-36.434 -33.27)",
    style: {
      strokeWidth: ".2px",
      stroke: "currentColor",
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26721",
    d: "M48.4 103.461a1.759 1.759 0 0 1-1.14 1.6 1.658 1.658 0 0 1-1.863-.39 1.6 1.6 0 0 1-.36-1.935 20.064 20.064 0 0 1 1.1-1.957.549.549 0 0 1 .955-.033 8.329 8.329 0 0 1 1.214 2.256 4.273 4.273 0 0 1 .09.455zm-1.773-1.339c-.213.451-.406.809-.552 1.185a.5.5 0 0 0 .232.608.547.547 0 0 0 .658-.012.5.5 0 0 0 .212-.615c-.148-.367-.336-.717-.55-1.165z",
    transform: "translate(-34.604 -86.709)",
    style: {
      fill: "currentColor"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.91210a649dec057479a171aa7957a23a.svg";
export { ForwardRef as ReactComponent };